import { useEffect } from 'react';

import { VUEX_THEME } from './constant';
import { VThemeContext } from './context';
import type { VThemeProviderProps } from './type';

const ROOT = document.documentElement;

export const VThemeProvider = ({
  children,
  theme,
}: React.PropsWithChildren<VThemeProviderProps>) => {
  const activeTheme = theme ?? VUEX_THEME;

  useEffect(() => {
    Object.entries(activeTheme).forEach(([key, propValueMap]) => {
      Object.entries(propValueMap).forEach(([prop, value]) => {
        ROOT.style.setProperty(`--color-${key}-${prop}`, value);
      });
    });
  }, [activeTheme]);

  return (
    <VThemeContext.Provider
      value={{
        theme: activeTheme,
        themeName: activeTheme.name,
      }}
    >
      {children}
    </VThemeContext.Provider>
  );
};
